<template lang="html">
    <div class="main-form__container">
        <div class="card__title"> Configurează-ți profilul </div>
        <div class="card__subtitle" v-if="currentStep && stepsTitles">
            Pasul {{currentStep}} -
            <span>
                {{stepsTitles[currentStep-1]}}
            </span>
        </div>

        <FormUpdatePassword v-if="currentStep == 1"
            @activeButton="activeNextStep = $event"
            @keyup.enter.native="nextStep"
        />

        <FormUpdateProfile v-if="currentStep == 2"
            @activeButton="activeNextStep = $event"
            @keyup.enter.native="nextStep"
        />

        <FormUpdateImageAndVideo v-if="currentStep == 3  && user"
            @activeButton="activeNextStep = $event"
            @keyup.enter.native="nextStep"
        />

        <br v-if="currentStep == 3"><br v-if="currentStep == 3">

        <FormUpdateTitleAndBasePrice v-if="currentStep == 4"
            @activeButton="activeNextStep = $event"
            @keyup.enter.native="nextStep"
        />

        <FormUpdateDescription v-if="currentStep == 5"
            @activeButton="activeNextStep = $event"
        />

        <FormUpdateTimetable v-if="currentStep == 6"
            @activeButton="activeNextStep = $event"
            @keyup.enter.native="nextStep"
        />

        <UiButton
            shape="square"
            name="Urmatorul pas"
            class="footer-button"
            :disabled="!activeNextStep"
            @click="nextStep"/>

        <UiNotification/>
    </div>
</template>

<script>

import UiButton from '@/components/ui/Button'
import UiNotification from '@/components/ui/Notification'

import FormUpdatePassword from '@/components/forms/Settings/Password'
import FormUpdateProfile from '@/components/forms/Settings/Profile'
import FormUpdateImageAndVideo from '@/components/forms/Settings/ImageAndVideo'
import FormUpdateTitleAndBasePrice from '@/components/forms/Settings/TitleAndBasePrice'
import FormUpdateDescription from '@/components/forms/Settings/Description'
import FormUpdateTimetable from '@/components/forms/Settings/Timetable'

import { mapGetters, mapActions } from 'vuex'

export default {
    components: {
        UiButton,
        UiNotification,
        FormUpdatePassword,
        FormUpdateProfile,
        FormUpdateImageAndVideo,
        FormUpdateTitleAndBasePrice,
        FormUpdateDescription,
        FormUpdateTimetable
    },
    data() {
        return {
            activeNextStep: false,
            stepsTitles: [
                'Parola',
                'Detalii profil',
                'Imagine si  videoclip de profil',
                'Titlu si pret de baza ',
                'Descriere',
                'Configurate orar de lucru'
            ]
        };
    },
    computed: {
        ...mapGetters({
            steps: 'settings/steps',
            currentStep: 'settings/currentStep',
            user: 'user/user'
        })
    },
    mounted() {
        this.fetchInvite();
    },
    methods: {
        ...mapActions({
            fetchInvite: 'settings/fetchInvite',
            updatePassword: 'settings/updatePassword',
            updateDetails: 'settings/updateDetails',
            updateDescription: 'settings/updateDescription',
            updateTimetable: 'settings/updateTimetable',
            fetchUser: 'user/user',
        }),
        test(event) {},
        nextStep() {
            switch(this.currentStep) {
                case 1: {
                    if(this.activeNextStep) {
                        this.updatePassword();
                        this.$store.state.settings.currentStep = 2;
                        this.activeNextStep = false;
                    }
                    break;
                }
                case 2: {
                    if(this.activeNextStep) {
                        this.updateDetails('profile');
                        this.$store.state.settings.currentStep = 3;
                        this.activeNextStep = true;
                    }
                    break;
                }
                case 3: {
                    if(this.activeNextStep) {
                        this.$store.state.settings.currentStep = 4;
                        this.activeNextStep = false;
                    }
                    break;
                }
                case 4: {
                    if(this.activeNextStep) {
                        this.updateDetails('titleAndBasePrice');
                        this.$store.state.settings.currentStep = 5;
                        this.activeNextStep = false;
                    }
                    break;
                }
                case 5: {
                    if(this.activeNextStep) {
                        this.updateDescription();
                        this.$store.state.settings.currentStep = 6;
                        this.activeNextStep = false;
                    }
                    break;
                }
                case 6: {
                    if(this.activeNextStep) {
                        this.updateTimetable();
                        this.$store.state.settings.currentStep = 6;
                        this.activeNextStep = false;
                    }
                    break;
                }
            }
        },
        setActiveButton(event) {
            this.activeNextStep = event;
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/scss/auth-main";

.right-panel {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    z-index: 1;

    @include media-breakpoint-up(md) {
        margin: auto auto;
        width: 90%;
        height: auto;
        display: column;
    }
}
.round-button {
    max-width: 100% !important;
}

.card {
    margin: 25px 30px;
    width: 80%;
    justify-content: center;
    max-width: 700px;
    margin: auto auto;

    @include media-breakpoint-up(md) {
        margin: auto auto;
        width: 90%;
    }

    &__title {
        font-size: 40px;
        text-align: center;
        margin: 25px 0;
        color: $color-gray;
    }

    &__subtitle {
        font-family: "Roboto";
        font-weight: 300;
        font-size: 18px;
        color: $color-gray;
        max-width: 450px;
        margin: 30px auto 25px auto;
        text-align: center;

        span {
            font-weight: 450;
        }
    }
}
</style>
